// Utilidades de fecha centralizadas para leads y chat.
// IMPORTANTE: cada función replica EXACTAMENTE el comportamiento que tenían
// las copias locales en sus archivos de origen (no unificar redondeos/fallbacks).

const MS_PER_DAY = 1000 * 60 * 60 * 24

// Fecha de última interacción del lead (cadena ultima_interaccion → updated_at → created_at)
export const getLastInteractionDate = (lead) =>
  new Date(lead.ultima_interaccion || lead.updated_at || lead.created_at)

// Variante de kanban-mobile: cae a epoch (0) si el lead no tiene ninguna fecha
export const getLastInteractionDateOrEpoch = (lead) =>
  new Date(lead.ultima_interaccion || lead.updated_at || lead.created_at || 0)

// Días sin actualización — redondeo hacia arriba (Math.ceil).
// Origen: KanbanPage.jsx y kanban-column.jsx (idénticas).
export const getDaysSinceUpdate = (lead) => {
  const lastUpdate = getLastInteractionDate(lead)
  const now = new Date()
  const diffTime = Math.abs(now - lastUpdate)
  return Math.ceil(diffTime / MS_PER_DAY)
}

// Días desde última interacción — redondeo hacia abajo (Math.floor), 999 si no hay fecha.
// Origen: KanbanPage.jsx (recordatorios).
export const getDaysSinceLastInteraction = (lead) => {
  const lastInteraction = lead.ultima_interaccion || lead.updated_at || lead.created_at
  if (!lastInteraction) return 999
  const diff = Date.now() - new Date(lastInteraction).getTime()
  return Math.floor(diff / MS_PER_DAY)
}

// Días sin actividad — redondeo hacia abajo (Math.floor), 0 si no hay fecha.
// Origen: lead-card.jsx (badge de inactividad).
export const getDaysSinceInteraction = (lead) => {
  const lastInteraction = lead.ultima_interaccion || lead.updated_at || lead.created_at
  if (!lastInteraction) return 0
  const lastDate = new Date(lastInteraction)
  const now = new Date()
  const diffTime = Math.abs(now - lastDate)
  return Math.floor(diffTime / MS_PER_DAY)
}

// ── Pre-aviso de auto-archivado ──
// Espejo de las reglas de autoArchiveStaleLeads (src/lib/supabase/leads.js):
// 30 días sin ultima_interaccion, solo etapas nuevo/contactado, protegidos
// los que tienen fecha_cita, intervencion_humana o calidad caliente.
// Devuelve los días que faltan para archivarse (0..AVISO_DIAS) o null si
// no aplica / falta mucho.
export const AUTO_ARCHIVE_DAYS = 30
const ARCHIVE_WARNING_WINDOW = 5

export const getDaysToAutoArchive = (lead) => {
  const stage = String(lead?.estado_lead || "").toLowerCase()
  if (stage !== "nuevo" && stage !== "contactado") return null
  if (lead?.fecha_cita) return null
  const human = lead?.intervencion_humana === true || lead?.intervencion_humana === "true" || lead?.intervencion_humana === 1
  if (human) return null
  if (String(lead?.calidad_lead || "").toLowerCase() === "caliente") return null
  // El archivador filtra estrictamente por ultima_interaccion (NULL nunca se archiva)
  if (!lead?.ultima_interaccion) return null
  const days = Math.floor((Date.now() - new Date(lead.ultima_interaccion).getTime()) / MS_PER_DAY)
  const left = AUTO_ARCHIVE_DAYS - days
  if (left > ARCHIVE_WARNING_WINDOW) return null
  return Math.max(left, 0)
}

// Devuelve YYYY-MM-DD en zona local — clave para agrupar mensajes por día.
// Origen: lead-unified-view.jsx.
export const getDayKey = (iso) => {
  if (!iso) return ""
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ""
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
}
